window._bd_share_config = {
    "common": {
        "bdText": "冰川2019旗舰网游《龙武》首届电竞跨区赛正式赛即将开打，全新国战电竞玩法火热上线，八大统战率军对抗引爆跨区竞技大战！龙武兄弟兄弟入驻新区领巨额福利，送炫酷时装、坐骑、神器！",      //分享的内容
        "bdPic": "http://lw.cdh.dev.q1.com/huodong/kqjjs/img/share.jpg?v=1",      //分享的图片
        "bdSize": "16",    // 分享按钮大小 有：16,24,32
    },
    "share": {}
};
with (document) 0[(getElementsByTagName('head')[0] || body).appendChild(createElement('script')).src = 'https://lw2.ssl.q1.com/static/api/js/share.js?v=8986059.js?cdnversion=' + ~(-new Date() / 36e5)];